import * as React from "react";
import { ProtectiveFunction } from "../models/ProtectiveFunction";
import { SFT_Targets } from "../models/SFT_Targets";
import { ProjectInfoHeader } from "./ProjectInfoHeader";
import { FunctionStatsHeader } from "./FunctionStatsHeader";
import { countrydetails } from "../models/countrydetails";
import { PT_ProtectiveFunction } from "../models/PT_ProtectiveFunction";
import { HFTResults } from "../models/HFTResults";
import { CalculationResults } from "../models/CalculationResults";
import { Area } from "../models/Area";

interface Props {
  protectiveFunction: ProtectiveFunction;
  sftTargets: SFT_Targets;
  onCalculateButtonHandler: () => void;
  calculations: CalculationResults;
  pfdPieChartData: countrydetails[];
  strPieChartData: countrydetails[];
  calculationResults?: PT_ProtectiveFunction;
  hftResults?: HFTResults;
  handleTargetSpecUpdate: (target_pfd: number, target_mttf: number) => void;
  onExitButtonClicked: () => void;
  onForwardOrBackButtonClicked: (direction: "Back" | "Forward") => void;
  onZoomButtonsClick: (button: "Zoom In" | "Zoom Out" | "Reset") => void;
  onUpgradeButtonClick: () => void;
  userName: string;
  readOnly: boolean;
  area: Area;
}

export class Header extends React.Component<Props, {}> {
  constructor(props: Props) {
    super(props);
  }

  render() {
    return (
      <div>
        <ProjectInfoHeader
          protectiveFunction={this.props.protectiveFunction}
          area={this.props.area}
          userName={this.props.userName}
        />
        <FunctionStatsHeader
          sftTargets={this.props.sftTargets}
          calculations={this.props.calculations}
          pfdPieChartData={this.props.pfdPieChartData}
          strPieChartData={this.props.strPieChartData}
          calculationResults={this.props.calculationResults}
          hftResults={this.props.hftResults}
          protectiveFunction={this.props.protectiveFunction}
          handleTargetSpecUpdate={this.props.handleTargetSpecUpdate}
        />
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            border: "1px solid black",
            paddingTop: "5px",
            paddingBottom: "3px"
          }}
        >
          <div style={{ paddingLeft: "10px" }}>
            <img
              src="/HTMLImages/Elements/Back.png"
              id="back"
              title="Backward"
              alt="Backward"
              onClick={_ => this.props.onForwardOrBackButtonClicked("Back")}
            />
            <img
              src="/HTMLImages/Elements/Forth.png"
              id="Forth"
              title="Forward"
              alt="Forward"
              onClick={_ => this.props.onForwardOrBackButtonClicked("Forward")}
            />
            <input
              type="button"
              value="Exit"
              id="backpage"
              onClick={this.props.onExitButtonClicked}
            />
          </div>
          <div>
            <input
              type="button"
              value="Calculate and Save"
              id="calculations"
              onClick={this.props.onCalculateButtonHandler}
              style={{ marginRight: "5px" }}
              disabled={this.props.readOnly}
            />
          </div>
          <div style={{ paddingRight: "10px" }}>
            <img
              src="/HTMLImages/Elements/Zoom in.png"
              id="zoomin"
              title="Zoom in"
              onClick={_ => this.props.onZoomButtonsClick("Zoom In")}
            />
            <img
              src="/HTMLImages/Elements/zoom out.png"
              id="zoomout"
              title="Zoom out"
              onClick={_ => this.props.onZoomButtonsClick("Zoom Out")}
            />
            <input
              type="button"
              value="Reset"
              id="reset"
              title="Reset zoom"
              onClick={_ => this.props.onZoomButtonsClick("Reset")}
            />
            {/*
            <button onClick={this.props.onUpgradeButtonClick}>Upgrade</button>
            */}
          </div>
        </div>
      </div>
    );
  }
}
